import { render, staticRenderFns } from "./email-verification-login.vue?vue&type=template&id=1cca9d72&scoped=true&"
import script from "./email-verification-login.vue?vue&type=script&lang=js&"
export * from "./email-verification-login.vue?vue&type=script&lang=js&"
import style0 from "./email-verification-login.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./email-verification-login.vue?vue&type=style&index=1&id=1cca9d72&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "1cca9d72",
  null
  
)

export default component.exports